module.exports = __webpack_public_path__ + "static/jana_falk-4c7af3d462fb6c77f1db1c00bc168bf7.jpg";